module.exports = __webpack_public_path__ + "static/media/slider-image-2@3x.d9659dbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/02/02/assets/slider-image-2@3x.svg
// module id = 440
// module chunks = 0